import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const ContattoContext = React.createContext(null);

const { Provider } = ContattoContext;

export const ContattoProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        contatto: null,
        tipiContatti: null,
        tipiContattiOptions: [],
        contatti: null,
    });

    const { contatti } = state;

    const [isLoadingContatto, setIsLoadingContatto] = useState(false);
    const getContattoAsync = async (ufficioId, contattoId) => {
        try {
            setIsLoadingContatto(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetContatto({ ufficioId, contattoId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            setState({ contatto: { ...result, inizioValidita: new Date(result.inizioValidita), fineValidita: result.fineValidita ? new Date(result.fineValidita) : null } });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingContatto(false);
        }
    }

    const [isUpdatingContatto, setIsUpdatingContatto] = useState(false);
    const updateContattoAsync = async (ufficioId, contattoId, tipo, updateContatto) => {
        try {
            setIsUpdatingContatto(true);
            if (window.confirm("Confermare la modifica?")) {
                const r = await fetchAuthorized(ApiRoutes.Ufficio.UpdateContatto({ ufficioId, contattoId, tipo }), {
                    method: HttpMethods.POST,
                    body: JSON.stringify({ ...updateContatto, inizioValidita: new Date(updateContatto.inizioValidita), fineValidita: updateContatto.fineValidita ? new Date(updateContatto.fineValidita) : null }),
                });
                const result = await r.json();
                setState({ contatto: { ...result, inizioValidita: new Date(result.inizioValidita), fineValidita: result.fineValidita ? new Date(result.fineValidita) : null } });
                showSuccessMessage("Attributo aggiornato");
                window.close();
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingContatto(false);
        }
    }

    const [isAddingContatto, setIsAddingContatto] = useState(false);
    const addContattoAsync = async (ufficioId, tipoContattoId, addContatto) => {
        try {
            setIsAddingContatto(true);
            if (window.confirm("Confermare l'inserimento?")) {
                const r = await fetchAuthorized(ApiRoutes.Ufficio.AddContatto({ ufficioId, tipoContattoId, }), {
                    method: HttpMethods.PUT,
                    body: JSON.stringify({ ...addContatto, inizioValidita: new Date(addContatto.inizioValidita), fineValidita: addContatto.fineValidita ? new Date(addContatto.fineValidita) : null }),
                });
                const result = await r.json();
                setState({ contatto: { ...result, inizioValidita: new Date(result.inizioValidita), fineValidita: result.fineValidita ? new Date(result.fineValidita) : null } });
                showSuccessMessage("Attributo creato")
                window.close();
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingContatto(false);
        }
    }

    const [isLoadingTipiContatti, setIsLoadingTipiContatti] = useState(false);
    const getTipiContattiAsync = async (term = null, pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingTipiContatti(true);
            const r = await fetchAuthorized(ApiRoutes.TipoContatto.GetTipiContatti({ pageIndex, pageSize, term }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, inizioValidita: new Date(e.inizioValidita), fineValidita: e.fineValidita ? new Date(e.fineValidita) : null, } });
            setState({ tipiContatti: list, tipiContattiOptions: list.result.map(e => { return { tipoContattoId: e.id, label: `${e.nome}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiContatti(false);
        }
    }

    const [isDeletingContatto, setIsDeletingContatto] = useState(false);
    const deleteContattoAsync = async (ufficioId, contattoId) => {
        try {
            setIsDeletingContatto(true);
            if (window.confirm("Confermare l'eliminazione?")) {
                const r = await fetchAuthorized(ApiRoutes.Ufficio.DeleteContatto({ ufficioId, contattoId }), {
                    method: HttpMethods.DELETE
                });
                setState({ contatti: contatti.filter(x => x.id != contattoId) });
                showSuccessMessage(`Attributo con id ${contattoId} dell'ufficio con id ${ufficioId} eliminato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingContatto(false);
        }
    }

    const [isLoadingContatti, setIsLoadingContatti] = useState(false);
    const getContattiAsync = async (ufficioId, pageIndex = 0, pageSize = 100, padreId = null) => {
        try {
            setIsLoadingContatti(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetContatti({ ufficioId, padreId, pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ contatti: list, });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingContatti(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingContatto,
            getContattoAsync,

            isUpdatingContatto,
            updateContattoAsync,

            isAddingContatto,
            addContattoAsync,

            isDeletingContatto,
            deleteContattoAsync,

            isLoadingTipiContatti,
            getTipiContattiAsync,

            isLoadingContatti,
            getContattiAsync,
        }}>
            {props.children}
        </Provider>
    );
}